// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 2P2seF7EsNRtVPgrUDdpUM
// Component: YybspqvfQD
import * as React from "react";
import { Link } from "gatsby";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import LatestPostsWrapper from "../../LatestPostsWrapper"; // plasmic-import: 1azDMqNFsw/component
import Copyright from "../../Copyright"; // plasmic-import: smhgwqfGPU/component
import "@plasmicapp/react-web/lib/plasmic.css";
import * as projectcss from "./plasmic_isaacpalka_com.module.css"; // plasmic-import: 2P2seF7EsNRtVPgrUDdpUM/projectcss
import * as sty from "./PlasmicBlog.module.css"; // plasmic-import: YybspqvfQD/css

createPlasmicElementProxy;

export const PlasmicBlog__VariantProps = new Array();

export const PlasmicBlog__ArgProps = new Array();

const $$ = {};

export function Head() {
  return (
    <>
      <meta name="twitter:card" content="summary" />
      <title key="title">{PlasmicBlog.pageMetadata.title}</title>
      <meta
        key="og:title"
        property="og:title"
        content={PlasmicBlog.pageMetadata.title}
      />

      <meta
        key="twitter:title"
        name="twitter:title"
        content={PlasmicBlog.pageMetadata.title}
      />
    </>
  );
}

function PlasmicBlog__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  return (
    <React.Fragment>
      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__zhk3L)}>
            <p.PlasmicLink
              data-plasmic-name={"back"}
              data-plasmic-override={overrides.back}
              className={classNames(
                projectcss.all,
                projectcss.a,
                projectcss.__wab_text,
                sty.back
              )}
              component={Link}
              href={`/`}
              platform={"gatsby"}
            >
              {"\u25c4 Back Home"}
            </p.PlasmicLink>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__c5BPc)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__jyfP9)}>
                <h1
                  data-plasmic-name={"h1"}
                  data-plasmic-override={overrides.h1}
                  className={classNames(
                    projectcss.all,
                    projectcss.h1,
                    projectcss.__wab_text,
                    sty.h1
                  )}
                >
                  {"Tech-nically Speaking"}
                </h1>
                <p
                  className={classNames(
                    projectcss.all,
                    projectcss.p,
                    projectcss.__wab_text,
                    sty.p__aTef
                  )}
                >
                  {"Practical Insights on Tech and Leadership"}
                </p>
                <p
                  className={classNames(
                    projectcss.all,
                    projectcss.p,
                    projectcss.__wab_text,
                    sty.p__wLwu5
                  )}
                >
                  {"by Isaac Palka"}
                </p>
              </div>
              <LatestPostsWrapper
                data-plasmic-name={"latestPostsWrapper"}
                data-plasmic-override={overrides.latestPostsWrapper}
                className={classNames("__wab_instance", sty.latestPostsWrapper)}
              />
            </p.Stack>
          </div>
          <Copyright
            data-plasmic-name={"copyright"}
            data-plasmic-override={overrides.copyright}
            className={classNames("__wab_instance", sty.copyright)}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: ["root", "back", "h1", "latestPostsWrapper", "copyright"],
  back: ["back"],
  h1: ["h1"],
  latestPostsWrapper: ["latestPostsWrapper"],
  copyright: ["copyright"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicBlog__ArgProps,
          internalVariantPropNames: PlasmicBlog__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicBlog__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicBlog";
  } else {
    func.displayName = `PlasmicBlog.${nodeName}`;
  }
  return func;
}

export const PlasmicBlog = Object.assign(
  // Top-level PlasmicBlog renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    back: makeNodeComponent("back"),
    h1: makeNodeComponent("h1"),
    latestPostsWrapper: makeNodeComponent("latestPostsWrapper"),
    copyright: makeNodeComponent("copyright"),
    // Metadata about props expected for PlasmicBlog
    internalVariantProps: PlasmicBlog__VariantProps,
    internalArgProps: PlasmicBlog__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "Blog",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicBlog;
/* prettier-ignore-end */
